import React, { useState } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import ImportantToKnow from "../components/ImportantToKnow"; 
import api from "../api/Api.js";
import modifycarImage from "../assets/images/bg1.jpg";

const ModifyReservation = () => {
  const [formData, setFormData] = useState({
    operationType: "0",
    referenceCode: "",
    email: "",
    details: "",
  });

  const [loading, setLoading] = useState(false);

  // ============================================================
  // HANDLE INPUT
  // ============================================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ============================================================
  // VALIDATE EMAIL
  // ============================================================

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // ============================================================
  // SUBMIT
  // ============================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ----------------------------------------------------------
    // BASIC VALIDATION
    // ----------------------------------------------------------

    const referenceCode =
      formData.referenceCode.trim();

    const email =
      formData.email.trim();

    const details =
      formData.details.trim();

    if (!referenceCode) {
      alert("Please enter booking reference code.");
      return;
    }

    if (!email) {
      alert("Please enter email address.");
      return;
    }

    if (!isValidEmail(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!details) {
      alert(
        "Please enter modification/cancellation details."
      );
      return;
    }

    // ----------------------------------------------------------
    // PREVENT DOUBLE SUBMIT
    // ----------------------------------------------------------

    if (loading) {
      return;
    }

    try {
      setLoading(true);

      console.log(
        "Submitting Modify Reservation:",
        {
          operationType:
            formData.operationType,
          referenceCode,
          email,
          details,
        }
      );

      // --------------------------------------------------------
      // API REQUEST
      // --------------------------------------------------------

      const response = await api.post(
        "/reservations/modify",
        {
          operationType:
            formData.operationType,

          referenceCode,

          email,

          details,
        }
      );

      console.log(
        "MODIFY RESERVATION RESPONSE:",
        response.data
      );

      const result = response.data;

      // --------------------------------------------------------
      // SUCCESS
      // --------------------------------------------------------

      if (result.success) {
        alert(
          result.message ||
            "Your modification request submitted."
        );

        // Clear form
        setFormData({
          operationType: "0",
          referenceCode: "",
          email: "",
          details: "",
        });

        return;
      }

      // --------------------------------------------------------
      // BUSINESS ERROR
      // --------------------------------------------------------

      alert(
        result.message ||
          "Unable to submit modification request."
      );
    } catch (error) {
      console.error(
        "MODIFY RESERVATION ERROR:",
        error
      );

      console.error(
        "ERROR RESPONSE:",
        error.response
      );

      const message =
        error.response?.data?.message ||
        "Unable to submit modification request.";

      alert(message);
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // OPERATION LABEL
  // ============================================================

  const operationLabel =
    formData.operationType === "1"
      ? "Cancellation"
      : "Modification";

  // ============================================================
  // RETURN
  // ============================================================

  return (
    <>
      <div className="p20">

        <div className="p0 container container2">

          {/* ==================================================
              LEFT SIDEBAR
          ================================================== */}

          <div
            className="col-md-4 sidebar"
            style={{
              float: "left",
            }}
          >

            <div className="car-box price-box">

              <img
                src={modifycarImage}
                alt="Modify Reservation"
                className="car-img"
              />

            </div>

            <div className="clearfix"></div>

          </div>

          {/* ==================================================
              MAIN CONTENT
          ================================================== */}

          <div
            className="col-md-8 main-content"
            style={{
              float: "left",
            }}
          >

            <div className="rate">
              Modify Reservation :
            </div>

            <div
              className="price-box"
              style={{
                padding: "0px",
              }}
            >

              <div className="rate-box">

                <div
                  className="proso"
                  style={{
                    padding: "30px",
                  }}
                >

                  <form
                    name="frmModRev"
                    id="frmModRev"
                    onSubmit={handleSubmit}
                    autoComplete="off"
                  >

                    <div className="c-box-left box-line">

                      {/* ======================================
                          OPERATION TYPE
                      ======================================= */}

                      <div
                        className="col-lg-4 form-group mr-2"
                        style={{
                          float: "left",
                        }}
                      >

                        <div className="p-line ht">

                          Operation type :

                          <span
                            style={{
                              color: "#f95d2d",
                              fontWeight: "normal",
                            }}
                          >
                            *
                          </span>

                        </div>

                        <div className="p-line1">

                          <select
                            name="operationType"
                            id="selTitle"
                            className="verysmallfrmtxtbox"
                            value={
                              formData.operationType
                            }
                            onChange={handleChange}
                            disabled={loading}
                          >

                            <option value="0">
                              MODIFY
                            </option>

                            <option value="1">
                              CANCEL
                            </option>

                          </select>

                        </div>

                      </div>

                      {/* ======================================
                          BOOKING REFERENCE
                      ======================================= */}

                      <div
                        className="col-lg-4 form-group mr-2"
                        style={{
                          float: "left",
                        }}
                      >

                        <div className="p-line ht">

                          Booking reference code :

                          <span
                            style={{
                              color: "#f95d2d",
                              fontWeight: "normal",
                            }}
                          >
                            *
                          </span>

                        </div>

                        <div className="p-line1">

                          <input
                            type="text"
                            name="referenceCode"
                            id="referenceCode"
                            className="frmtxtbox1"
                            maxLength="30"
                            value={
                              formData.referenceCode
                            }
                            onChange={handleChange}
                            disabled={loading}
                          />

                        </div>

                      </div>

                      {/* ======================================
                          EMAIL
                      ======================================= */}

                      <div
                        className="col-lg-4 form-group mr-2"
                        style={{
                          float: "left",
                        }}
                      >

                        <div className="p-line ht">

                          Email id :

                          <span
                            style={{
                              color: "#f95d2d",
                              fontWeight: "normal",
                            }}
                          >
                            *
                          </span>

                        </div>

                        <div className="p-line1">

                          <input
                            type="email"
                            name="email"
                            id="txtconfirmemail"
                            className="frmtxtbox1"
                            maxLength="70"
                            value={
                              formData.email
                            }
                            onChange={handleChange}
                            disabled={loading}
                          />

                        </div>

                      </div>

                      <div className="clearfix"></div>

                      {/* ======================================
                          DETAILS
                      ======================================= */}

                      <div
                        className="col-lg-12 form-group mr-2"
                        style={{
                          float: "left",
                        }}
                      >

                        <div className="p-line ht">

                          {operationLabel} details :

                          <span
                            style={{
                              color: "#f95d2d",
                              fontWeight: "normal",
                            }}
                          >
                            *
                          </span>

                        </div>

                        <div className="p-line1">

                          <textarea
                            name="details"
                            className="frmtxtarea"
                            rows="5"
                            cols="13"
                            style={{
                              width: "100%",
                              height: "160px",
                            }}
                            value={
                              formData.details
                            }
                            onChange={handleChange}
                            disabled={loading}
                            placeholder={
                              formData.operationType ===
                              "1"
                                ? "Enter cancellation details..."
                                : "Enter modification details..."
                            }
                          />

                        </div>

                      </div>

                    </div>

                    <div className="clearfix"></div>

                    {/* ======================================
                        BOTTOM SECTION
                    ======================================= */}

                    <div
                      className="col-lg-12 form-group mr-2"
                      style={{
                        float: "left",
                      }}
                    >

                      <div className="yes">

                        <div
                          className="termlink"
                          style={{
                            backgroundColor:
                              "#FFFFFF",
                          }}
                        >

                          <label>

                            <span
                              style={{
                                color: "red",
                              }}
                            >
                              **
                            </span>

                            <strong>
                              {" "}
                              You can modify your booking
                              the latest 3 day(s) before
                              your pick-up date
                            </strong>

                          </label>

                          <div className="clearfix"></div>

                        </div>

                      </div>

                      {/* ====================================
                          BUTTON
                      ===================================== */}

                      <div
                        className="yes1"
                        style={{
                          float: "right",
                        }}
                      >

                        <input
                          name="btnpersonaldtlssubmit"
                          id="btnpersonaldtlssubmit"
                          type="submit"
                          className="nextbutton1 nextbutton"
                          value={
                            loading
                              ? "Processing..."
                              : "Proceed"
                          }
                          disabled={loading}
                        />

                      </div>

                    </div>

                  </form>

                  <div className="clearfix"></div>

                </div>

              </div>

              <div className="clearfix"></div>

            </div>

            <div className="clearfix"></div>

          </div>

          <div className="clearfix"></div>

        </div>
 <ImportantToKnow />
      </div>
    </>
  );
};

export default ModifyReservation;